export const REQUEST_CREATED_EVENT = "incentive-request-created";

export function dispatchRequestCreated(): void {
  window.dispatchEvent(new CustomEvent(REQUEST_CREATED_EVENT));
}
